import type { I18nTranslations } from "@i18n/layouts"

export const enTranslations: I18nTranslations = {
  sidebar: {
    dashboard: "Dashboard",
    inbox: "Inbox",
    ecommerce: "E-commerce",
    usersList: "Users list",
    profile: "Profile",
    feed: "Feed",
    settings: "Settings",
    pages: "Pages",
    organizations: "Organizations",
    authentication: "Authentication",
    docs: "Docs",
    components: "Components",
    help: "Help",
  },
  navbar: {
    toggleSidebar: "Toggle sidebar",
    search: "Search",
    toggleTheme: "Toggle theme",
    notifications: "Notifications",
    settings: "Settings",
    profile: "Profile",
    logout: "Logout",
  },
}
